export const environment = {
  production: true,
  staging: false,
  appVersion: require('../../package.json').version,
  WS_PATH: 'wss://webdb-api-ws.blackhawksupply.com/ws',
  API_PATH: 'https://webdb-api.blackhawksupply.com'
};
